import { inject, Injectable, signal } from '@angular/core';
import { AuthService } from './auth.service';
import { BaseService } from './base.service';
import { ApiService } from './api.service';
import GasStationEvent from '../class/GasStationEvent';
import { lastValueFrom } from 'rxjs';

export type FuelDataAPI = {
  id_fuel_data: number;
  date_time: number;
  fk_device: number;
  client: string;
  supplier: string;
  address: string;
  fuel_type_detail: string;
  fk_fuel_type: number;
  outlet: string;
  total_fuel: number;
  unit_price: number;
  cost_ht: number;
  cost_tva: number;
  cost_ttc: number;
  driver_name: string;
};

type Range = {
  from: number;
  to: number;
};

type LoadArgs = {
  deviceUid: number;
  range: Range;
};

type GetParams = {
  token: string;
  id_device: number;
  from?: number;
  to?: number;
};

@Injectable({
  providedIn: 'root',
})
export class GasStationEventsService extends BaseService<FuelDataAPI[]> {
  public events = signal<GasStationEvent[] | null>(null);
  private _authService = inject(AuthService);

  constructor(private _apiService: ApiService) {
    super(_apiService);
  }

  public override HandleResponse(response) {
    return response;
  }

  public async load({ deviceUid, range }: LoadArgs) {
    try {
      const params: GetParams = {
        token: this._authService.$token(),
        id_device: deviceUid,
        from: range.from,
        to: range.to,
      };

      const response = await lastValueFrom(this.Get('getfueldata', params, true, 'v2'));
      if (Object.keys(response)?.length) {
        this.events.set(response.map(apiData => new GasStationEvent(apiData)));
      }
    } catch (error) {
      console.error('getfueldata error :', error);
    }
  }

  public get(id: GasStationEvent['id']) {
    for (const fuel of this.events()) {
      if (fuel.id === id) {
        return fuel;
      }
    }
  }
}
